export default class SessionStorage {
  static get(name) {
    return sessionStorage.getItem(name);
  }

  static save(name, value) {
    sessionStorage.setItem(name, value);
  }

  static remove(name) {
    sessionStorage.removeItem(name);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/StorageHandler/SessionStorage.js